



import Vue from 'vue'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import TileLayer from 'ol/layer/Tile'
import Map from 'ol/Map'
import View from 'ol/View'
import OSM from 'ol/source/OSM'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import Icon from 'ol/style/Icon'
import Style from 'ol/style/Style'
import { fromLonLat, transform } from 'ol/proj'
import {
    CATEGORIA_AMBIENTE,
    CATEGORIA_SERVIZI_AL_CITTADINO,
    CATEGORIA_SICUREZZA,
    CATEGORIA_STRADE_E_VIABILITA,
    CATEGORIA_VERDE_PUBBLICO,
    CATEGORIA_TRIBUTI_E_CATASTO,
    STATO_CHIUSA
} from '@/costanti_report'
import { OPEN_LAYER_GEOJSON_FORMAT } from '@/costanti'
// Costanti per la configurazione
const coordinateIniziali = [11.6191, 44.8370]
const zoomIniziale = 12
export default Vue.extend({
    data: () => ({
        map: null,
        vectorLayerRilevamenti: null
    }),
    computed: {
        ...mapGetters('reportMappa', ['segnalazioniGeojson']),
        ...mapState('reportFiltriSegnalazione', ['enteGestore']),
        ...mapState('modal', ['nuoveCoordinate']),
        ...mapGetters('auth', ['isAuthenticated'])
    },
    watch: {
        // quando i rilevameti vengono caricati
        segnalazioniGeojson(newValue) {
            // togliamo i rilevamenti precedenti
            this.vectorLayerRilevamenti.getSource().clear()
            // leggiamo i rilevamenti
            this.vectorLayerRilevamenti.getSource().addFeatures(OPEN_LAYER_GEOJSON_FORMAT.readFeatures(newValue))
        },
        // quando cambia l'indirizzo autocompletato, abbiamo nuove coordinate in cui andare
        nuoveCoordinate(newValue) {
            // se abbiamo le coordinate
            // ci spostiamo con un'animazione
            this.map.getView().animate({
                center: fromLonLat(newValue),
                zoom: 18,
                duration: 1000
            })
        },
        // === aggiorniamo le segnalazioni quando cambiano i filtri ===
        enteGestore(newValue) {
            this.caricaSegnalazioni({ light: true })
        }
    },
    methods: {
        ...mapActions('modal', ['showModal']),
        ...mapActions('reportMappa', ['cambiaSegnalazioneMostrata', 'caricaSegnalazioni']),
        ...mapMutations('reportMappa', ['SET_CENTRO_MAPPA'])
    },
    mounted() {
        // caichiamo i vettori layer
        this.vectorLayerRilevamenti = new VectorLayer({
            source: new VectorSource({
                features: undefined
            }),
            style: (feature: any, resolution) => {
                const catogoriaSegnalazione = feature.get('categoria_segnalazione')
                const statoSegnalazione = feature.get('stato_segnalazione')
                
                let src = null // '/report/logo.png'
                switch (catogoriaSegnalazione) {
                    case CATEGORIA_AMBIENTE: // 1
                        if (statoSegnalazione !== STATO_CHIUSA) {
                            src = '/report/images/ambiente_attivo_32x32.png'
                        } else {
                            src = '/report/images/ambiente_chiuso_32x32.png'
                        }
                        break
                    case CATEGORIA_SERVIZI_AL_CITTADINO: // 2
                        if (statoSegnalazione !== STATO_CHIUSA) {
                            src = '/report/images/servizi_al_cittadino_attivo_32x32.png'
                        } else {
                            src = '/report/images/servizi_al_cittadino_chiuso_32x32.png'
                        }
                        break
                    case CATEGORIA_SICUREZZA: // 3
                        if (statoSegnalazione !== STATO_CHIUSA) {
                            src = '/report/images/sicurezza_attivo_32x32.png'
                        } else {
                            src = '/report/images/sicurezza_chiuso_32x32.png'
                        }
                        break
                    case CATEGORIA_STRADE_E_VIABILITA: // 4
                        if (statoSegnalazione !== STATO_CHIUSA) {
                            src = '/report/images/strade_e_viabilita_attivo_32x32.png'
                        } else {
                            src = '/report/images/strade_e_viabilita_chiuso_32x32.png'
                        }
                        break
                    case CATEGORIA_VERDE_PUBBLICO: // 5
                        if (statoSegnalazione !== STATO_CHIUSA) {
                            src = '/report/images/verde_pubblico_attivo_32x32.png'
                        } else {
                            src = '/report/images/verde_pubblico_chiuso_32x32.png'
                        }
                        break
                    case CATEGORIA_TRIBUTI_E_CATASTO: // 6
                        if (statoSegnalazione !== STATO_CHIUSA) {
                            src = '/report/images/tributi_e_catasto_attivo_32x32.png'
                        } else {
                            src = '/report/images/tributi_e_catasto_chiuso_32x32.png'
                        }
                        break
                    }
            

                return [new Style({
                    image: new Icon(({
                        scale: 1,
                        src: src
                    }))
                })]
            }
        })

        // carichiamo la mappa
        this.map = new Map({
            target: 'map',
            controls: [],
            layers: [
                // open street map
                new TileLayer({
                    source: new OSM(),
                    preload: Infinity
                })
            ],
            // ci posizioniamo su casteldelci
            view: new View({
                center: fromLonLat([coordinateIniziali[0], coordinateIniziali[1]]),
                zoom: zoomIniziale
            })
        })

        // aggiugiamo il rilevamento alla mappa
        this.map.addLayer(this.vectorLayerRilevamenti)

        // display popup on click
        this.map.on('singleclick', (evt: any) => {
            if (!this.isAuthenticated) {
                this.showModal('login')
            } else {
                // il rilevamento cliccato
                const feature = this.map.forEachFeatureAtPixel(evt.pixel, (featureAtPixel: any, layer: any) => featureAtPixel)
                // se effettivamente abbiamo cliccato un rilevamento
                if (feature) {
                    const id = feature.get('id')
                    this.map.getView().animate({
                        center: evt.coordinate,
                        duration: 1000
                    })
                    // mostriamo il rilevamento
                    this.cambiaSegnalazioneMostrata(id)
                    this.showModal('report-info-rilevamento')
                } else {
                    // se abbiamo cliccato semplicemente sulla mappa
                    // settiamo il centro
                    this.SET_CENTRO_MAPPA(transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326'))
                    // animiamo lo spostamento
                    this.map.getView().animate({
                        center: evt.coordinate,
                        duration: 1000
                    })
                    // dialogo per aggiungere una segnalazione
                    this.showModal('report-aggiungi-segnalazione')
                }
            }
        })

        // BUG fix
        // senza questo scazza e schiaccia la mappa all inizio
        setTimeout(() => {
            this.map.updateSize()
        }, 200)
    }
})
